import type { HQEntity } from "../../core/entity/EntityType/HQ"
import { Property_HQ1_HQ1_GLTF_Model } from "../gltf_models.generated"
import makePropertyObject3DFactory from "./makePropertyObject3DFactory"

export default makePropertyObject3DFactory<HQEntity>(Property_HQ1_HQ1_GLTF_Model)